import { render } from "./BaseVideoPlayer.vue?vue&type=template&id=41d5c5ad"
import script from "./BaseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./BaseVideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__